import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { BulletStatus } from "../../../../../components/talent/components/feedback-status/feedback-status.styled";
import { LastActionStatus } from "../../../../../models/last-action-status.enum";
import { jobOfferStatusTypes } from "../../../../../models/candidate.model";
import { selectedSchema } from "./selected-status.utils";
import { NullStatus } from "./selected-status.styled";

const SelectedStatus: React.FC<{ 
  talentStatus?: LastActionStatus | jobOfferStatusTypes, 
  offer?: boolean
}> = ({ talentStatus, offer }) => {
  const { t } = useTranslation(["translation", "private-home-page"]);

  const status = useMemo(() => (!!talentStatus 
    ? talentStatus.toLocaleLowerCase() 
    : !offer 
    ? LastActionStatus.INTERVIEW
    : null
  ), [talentStatus, offer]);

  return status ? (
    <BulletStatus
      color={selectedSchema[status]?.color}
      offer={offer}
    >
      <p>{t(selectedSchema[status]?.title)}</p>
    </BulletStatus>
  ) : (
    <NullStatus />
  );
};

export default SelectedStatus;
